<template>
  <v-autocomplete
    v-model="VALORES_SELECIONADOS_COMPUTED"
    label="Produtos"
    outlined
    hide-details
    :loading="loading"
    :items="itens"
    multiple
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        color="red"
        indeterminate
      />
    </template>

    <template #prepend-item v-if="!desabilitar_botao_selecao_todos">
      <SysItemListaSelecionaTudo
        v-model="VALORES_SELECIONADOS_COMPUTED"
        :itens="itens"
        valor-chave="value"
     />

      <v-divider />
    </template>

    <template #selection="{item}">
      <template v-if="VALORES_SELECIONADOS_COMPUTED.indexOf(item.value) === 0">
        {{item.text }}
      </template>

      <template v-if="VALORES_SELECIONADOS_COMPUTED.indexOf(item.value) === 1">
        <span class="ml-1 text-gray-900">(+ {{VALORES_SELECIONADOS_COMPUTED.length - 1}})</span>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  }
}
</script>

<script setup>
import api from "@/api/api";
import {logout} from "@/helpers";
import {computed, onMounted, ref, watch} from "vue";
import SysItemListaSelecionaTudo from "@/components/utils/crud/SysItemListaSelecionaTudo.vue";

const props = defineProps({
  modelValue: Array,
  filiais: {
    type: Array,
    default: () => ([]),
  },
  segmentos: {
    type: Array,
    default: () => ([]),
  },
  secoes: {
    type: Array,
    default: () => ([]),
  },
  categorias: {
    type: Array,
    default: () => ([]),
  },
  fornecedores: {
    type: Array,
    default: () => ([]),
  },
  ids_produtos_permitidos: {
    type: Array,
    default: () => ([]),
    required: false
  },
  desabilitar_botao_selecao_todos: Boolean,
});

const emit = defineEmits(['update:modelValue']);

const VALORES_SELECIONADOS_COMPUTED = computed({
  get: () => props.modelValue,
  set: valor => emit('update:modelValue', valor),
})

const loading = ref(false);
const timer_recarregamento_dados = ref(null);

const FILTROS_COMPUTED = computed(() => ({
  filiais: props.filiais,
  segmentos: props.segmentos,
  secoes: props.secoes,
  categorias: props.categorias,
  fornecedores: props.fornecedores,
}));

watch(() => JSON.stringify(props), buscarProdutosAposTimer);

function buscarProdutosAposTimer() {
  clearTimeout(timer_recarregamento_dados.value);
  timer_recarregamento_dados.value = setTimeout(buscarProdutos, 2000);
}

onMounted(buscarProdutos);

const itens = ref([]);

function buscarProdutos() {
  loading.value = true;

  api.post('produtos', FILTROS_COMPUTED.value)
    .then(resposta => {
      const ids_set = new Set(props.ids_produtos_permitidos);

      const produtos = ids_set.size > 0
        ? resposta.data.produtos.filter(item => ids_set.has(item.idproduto))
        : resposta.data.produtos;

      itens.value = produtos.map(item => ({
        value: item.idproduto,
        text: `${item.idproduto} - ${item.descricao_produto}`,
      }));

      atualizarSelecionados();
    })
    .catch(logout)
    .finally(() => {
      loading.value = false;
    })
}

function atualizarSelecionados() {
  VALORES_SELECIONADOS_COMPUTED.value = VALORES_SELECIONADOS_COMPUTED.value.filter(
    selecionado => itens.value.some(item => String(item.value) === String(selecionado)))
}
</script>

<style scoped>
.text-gray-900 {
  color: #999;
}
</style>
